module.exports = __webpack_public_path__ + "img/radio-lines.f7ad580a.svg";